import React from "react";
import PropTypes from "prop-types";

import Row from "../../common/Row";
import Button from "../../common/Button";
import TextInput from "../../common/TextInput";
import ConfirmModal from "../../common/ConfirmModal";

const LinkOrganisatieFilterForm = (props) => {
    const {
        onCancel,
        onSearch,
        onChange,
        onAddSportclub,
        searchModel,
        errors,
        validationMessageType,
        modalIsOpen,
        modalSportclub,
        onCloseModal,
        nameFilterHasFocus
    } = props;

    function handleOnAddSportclub(id) {
        return function (event) {
            onAddSportclub(id, event);
        };
    }

    function handleOnCloseModal() {
        return function (event) {
            onCloseModal(event);
        };
    }

    return (
        <div>
            {modalIsOpen && <ConfirmModal
                isOpen={modalIsOpen}
                title="Link deze sportclub aan mijn sportfederatie"
                mainText={"Hiermee meld je aan Sport Vlaanderen dat " + modalSportclub.naam + " aangesloten is bij jouw sportfederatie."}
                confirmAction={handleOnAddSportclub(modalSportclub.id)}
                cancelAction={handleOnCloseModal()}
                confirmText="Ga verder"
                cancelText="Annuleer"
            />}
            <Row>
                <TextInput
                    name="naam"
                    label="Naam"
                    size={6}
                    onChange={onChange}
                    value={searchModel.naam}
                    validationMessage={errors ? errors['naam'] : ""}
                    validationMessageType={validationMessageType}
                    hasFocus={nameFilterHasFocus}
                />
                <TextInput
                    name="afkorting"
                    label="Afkorting"
                    size={6}
                    onChange={onChange}
                    value={searchModel.afkorting}
                    optional
                    validationMessage={errors ? errors['afkorting'] : ""}
                    validationMessageType={validationMessageType}
                />
            </Row>
            <Row>
                <TextInput
                    name="ondernemingsnummer"
                    label="Ondernemingsnummer"
                    size={6}
                    onChange={onChange}
                    value={searchModel.ondernemingsnummer}
                    optional
                    validationMessage={errors ? errors['ondernemingsnummer'] : ""}
                    validationMessageType={validationMessageType}
                />
                <TextInput
                    name="telefoon"
                    label="Telefoon"
                    size={6}
                    onChange={onChange}
                    value={searchModel.telefoon}
                    optional
                    validationMessage={errors ? errors['telefoon'] : ""}
                    validationMessageType={validationMessageType}
                />
            </Row>
            <Row>
                <TextInput
                    name="email"
                    label="E-mail"
                    size={6}
                    onChange={onChange}
                    value={searchModel.email}
                    optional
                    validationMessage={errors ? errors['email'] : ""}
                    validationMessageType={validationMessageType}
                />
                <TextInput
                    name="website"
                    label="Website"
                    size={6}
                    onChange={onChange}
                    value={searchModel.website}
                    optional
                    validationMessage={errors ? errors['website'] : ""}
                    validationMessageType={validationMessageType}
                />
            </Row>
            <Row>
                <Button onClick={onCancel} text="Annuleer" className="c-button--small o-col-2 c-input" />
                <p className="o-col-8">&nbsp;</p>
                <Button onClick={onSearch} text="Zoek" className="c-button--small o-col-2 c-input" />
            </Row>
        </div>
    );
};

LinkOrganisatieFilterForm.propTypes = {
    onCancel: PropTypes.func,
    onSearch: PropTypes.func,
    onChange: PropTypes.func,
    onAddSportclub: PropTypes.func,
    searchModel: PropTypes.object,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    modalIsOpen: PropTypes.bool,
    modalSportclub: PropTypes.object,
    onCloseModal: PropTypes.func,
    nameFilterHasFocus: PropTypes.bool
};

export default LinkOrganisatieFilterForm;